$(function() {
    'use strict';

    $(".nav_services a, .nav_header a, .cart_mini a")
        .each(function(index) {
            if (index != 0) {
                $("#beep-two").clone().attr("id", "beep-two" + index).appendTo($(this).parent());
            }
            $(this).data("beeper", index);
        })

        .mouseenter(function() {
            $("#beep-two" + $(this).data("beeper"))[0].volume = 0.3;
            $("#beep-two" + $(this).data("beeper"))[0].play();
        });

    $("#beep-two").attr("id", "beep-two0");
});